import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import PropTypes from 'prop-types';
import { createSelector } from 'reselect';

import { emptyArray } from 'ui-components/default-props/empty';

import { FulfillmentPlannerContext, useFulfillmentPlannerContext } from '../../../../../fulfillment-planner/context';
import { EXTERNAL_FULFILLMENTS, LOCAL_DELIVERY, STANDARD } from '../../../../../enums/csw-types';

import * as Actions from '../../../../../store/csw/csw.actions';
import { ErrorBoundary } from '../../../../error-boundary';
import { SellerPresetHotkey } from '../../../../hotkeys/seller-presets';
import { DrawerExternalConfiguration } from './external';
import { DrawerLocalDeliveryConfiguration } from './local-delivery';
import { DrawerShipmentConfiguration } from './shipment';

import { EXTERNAL } from '../../../../../constants/fulfillment-types';

const selectPresetFulfillmentPlanId = createSelector(
  (fulfillmentPlanId) => fulfillmentPlanId,
  (fulfillmentPlanId) => (fulfillmentPlanId ? [fulfillmentPlanId] : emptyArray),
);

export const DrawerFulfillmentConfiguration = ({ fulfillmentPlanId }) => {
  const { fulfillmentType } = useFulfillmentPlannerContext();
  const dispatch = useDispatch();
  useEffect(() => {
    const cswType = fulfillmentType === EXTERNAL ? EXTERNAL_FULFILLMENTS : STANDARD;

    if (fulfillmentPlanId.indexOf('-') === -1) {
      dispatch(Actions.initShipmentConfiguration(fulfillmentPlanId, cswType));
    }
    // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const errorMessageId = fulfillmentType === EXTERNAL ? 'sidebarCswExternal' : 'sidebarCswShipment';
  const CSW_CONFIGURATIONS = {
    [EXTERNAL_FULFILLMENTS]: DrawerExternalConfiguration,
    [LOCAL_DELIVERY]: DrawerLocalDeliveryConfiguration,
    [STANDARD]: DrawerShipmentConfiguration,
  };
  const hotkeyFpId = selectPresetFulfillmentPlanId(fulfillmentPlanId);
  return (
    <ErrorBoundary errorMessageId={errorMessageId}>
      <FulfillmentPlannerContext.Consumer>
        {({ applyPresetConfiguration, cswTypeId }) => {
          const Component = CSW_CONFIGURATIONS[cswTypeId];
          return (
            <SellerPresetHotkey fulfillmentPlanIds={hotkeyFpId} onApplyPreset={applyPresetConfiguration}>
              <Component fulfillmentPlanId={fulfillmentPlanId} />
            </SellerPresetHotkey>
          );
        }}
      </FulfillmentPlannerContext.Consumer>
    </ErrorBoundary>
  );
};

DrawerFulfillmentConfiguration.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
};
